import React, { useState } from 'react';
import { FaExclamationTriangle } from "react-icons/fa";
import styles from './bars.module.css';

function AlertBar({ message, icon }) {
    const [visible, setVisible] = useState(true);
    
    if (!visible || !message) return null;
    
    return (
        <div className={`${styles['info-bar']} ${styles['alert-bar']}`}>
            <span className={styles['alert-content']}>
                <span className={styles['alert-icon']}>
                    {icon || <FaExclamationTriangle />}
                </span>
                <span className={styles['alert-message']}>
                    {typeof message === 'string' ? message : message.message || message}
                </span>
            </span>
            <button
                onClick={() => setVisible(false)}
                className={styles['close-btn']}
                aria-label="Close alert bar"
            >
                &times;
            </button>
        </div>
    );
}

export default AlertBar;
